// Mobile Menu Functionality
import Papa from 'papaparse';
import './page-media';

(function() {
    'use strict';
    
    function initMobileMenu() {
        const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
        const navMenuWrapper = document.querySelector('.nav-menu-wrapper');
        
        console.log('Mobile menu toggle:', mobileMenuToggle);
        console.log('Nav menu wrapper:', navMenuWrapper);
        
        if (mobileMenuToggle && navMenuWrapper) {
            mobileMenuToggle.addEventListener('click', function(e) {
                e.preventDefault();
                console.log('Mobile menu clicked');
                
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                console.log('Current expanded state:', isExpanded);
                this.setAttribute('aria-expanded', !isExpanded);
                
                // Toggle menu visibility by adding/removing a class
                if (!isExpanded) {
                    navMenuWrapper.classList.add('menu-open');
                    document.body.classList.add('menu-open');
                    console.log('Menu opened');
                } else {
                    navMenuWrapper.classList.remove('menu-open');
                    document.body.classList.remove('menu-open');
                    console.log('Menu closed');
                }
            });
            
            // Close menu when clicking outside
            document.addEventListener('click', function(e) {
                if (!mobileMenuToggle.contains(e.target) && !navMenuWrapper.contains(e.target)) {
                    mobileMenuToggle.setAttribute('aria-expanded', 'false');
                    navMenuWrapper.classList.remove('menu-open');
                    document.body.classList.remove('menu-open');
                }
            });
            
            // Close menu on escape key
            document.addEventListener('keydown', function(e) {
                if (e.key === 'Escape') {
                    mobileMenuToggle.setAttribute('aria-expanded', 'false');
                    navMenuWrapper.classList.remove('menu-open');
                    document.body.classList.remove('menu-open');
                }
            });
        } else {
            console.log('Mobile menu elements not found');
        }
    }    
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initMobileMenu();
        });
    } else {
        initMobileMenu();
    }
})();

// Subscription Modal Functionality
(function() {
    'use strict';
    
    function initSubscribeModal() {
        const modal = document.getElementById('subscribe-modal');
        const triggers = document.querySelectorAll('[data-modal-trigger="subscribe"]');
        const closeBtn = modal ? modal.querySelector('.modal-close') : null;
        const form = document.getElementById('subscribe-form');
        const messageDiv = document.getElementById('subscribe-message');
        
        if (!modal || !form) return;
        
        // Open modal
        triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                modal.classList.add('modal-open');
                document.body.classList.add('modal-open');
                
                // Clear previous messages
                messageDiv.textContent = '';
                messageDiv.className = 'form-message';
                form.reset();
            });
        });
        
        // Close modal
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            });
        }
        
        // Close on backdrop click
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }
        });
        
        // Close on escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('modal-open')) {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }
        });
        
        // Handle form submission
        form.addEventListener('submit', async (e) => {
            e.preventDefault();
            
            const email = document.getElementById('subscribe-email').value;
            const ajaxUrl = window.shatnez_ajax?.ajaxurl || document.getElementById('subscribe-ajax-url')?.value;
            const nonce = window.shatnez_ajax?.nonce || document.getElementById('subscribe-nonce')?.value;
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalText = submitBtn.textContent;
            
            // Disable button and show loading
            submitBtn.disabled = true;
            submitBtn.textContent = 'Subscribing...';
            messageDiv.textContent = '';
            messageDiv.className = 'form-message';
            
            try {
                if (!ajaxUrl || !nonce) {
                    messageDiv.textContent = 'Unable to submit right now. Please refresh and try again.';
                    messageDiv.className = 'form-message error';
                    return;
                }

                const formData = new FormData();
                formData.append('action', 'shatnez_subscribe');
                formData.append('email', email);
                formData.append('nonce', nonce);
                
                const response = await fetch(ajaxUrl, {
                    method: 'POST',
                    body: formData
                });
                
                const data = await response.json();
                
                if (data.success) {
                    messageDiv.textContent = data.data.message;
                    messageDiv.className = 'form-message success';
                    form.reset();
                } else {
                    messageDiv.textContent = data.data.message;
                    messageDiv.className = 'form-message error';
                }
            } catch (error) {
                messageDiv.textContent = 'An error occurred. Please try again.';
                messageDiv.className = 'form-message error';
            } finally {
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            }
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSubscribeModal);
    } else {
        initSubscribeModal();
    }
})();

// Shatnez Listing Functionality
class ShatnezListing {
    constructor(locationType) {
        this.locationType = locationType;
        this.currentPage = 1;
        this.searchTerm = '';
        this.sortBy = 'date';
        this.sortDirection = 'desc';
        this.searchTimeout = null;
        this.items = [];
        
        this.init();
    }
    
    init() {
        this.bindEvents();
        this.initModal();
        this.initImageModal();
        this.bindAdminEvents();
        this.loadItems();
    }
    
    bindEvents() {
        // Search input with debounce
        const searchInput = document.getElementById('search-input');
        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.searchTerm = e.target.value;
                    this.currentPage = 1;
                    this.loadItems();
                }, 300);
            });
        }
        
        // Sort buttons
        const sortButtons = document.querySelectorAll('.sort-btn');
        if (sortButtons.length > 0) {
            // Set initial active state for date button
            const dateBtn = document.querySelector('[data-sort="date"]');
            if (dateBtn && !dateBtn.classList.contains('sort-btn--active')) {
                dateBtn.classList.add('sort-btn--active');
            }
            
            sortButtons.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    
                    const sortType = btn.dataset.sort;
                    const currentDirection = btn.dataset.direction;
                    
                    // Remove active class from all buttons
                    sortButtons.forEach(b => b.classList.remove('sort-btn--active'));
                    
                    // If clicking the same button, toggle direction
                    if (this.sortBy === sortType) {
                        const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';
                        btn.dataset.direction = newDirection;
                        this.sortDirection = newDirection;
                        
                        // Update arrow
                        const arrow = btn.querySelector('.sort-arrow');
                        if (arrow) {
                            arrow.innerHTML = newDirection === 'desc' ? '↓' : '↑';
                        }
                    } else {
                        // Switching to new sort type
                        this.sortBy = sortType;
                        this.sortDirection = currentDirection;
                    }
                    
                    // Add active class to clicked button
                    btn.classList.add('sort-btn--active');
                    
                    this.currentPage = 1;
                    this.loadItems();
                });
            });
        }
        
        // Export CSV button
        const exportBtn = document.getElementById('export-csv-btn');
        if (exportBtn) {
            exportBtn.addEventListener('click', () => {
                this.exportCSV();
            });
        }
        
        // Print button
        const printBtn = document.querySelector('.print-btn');
        if (printBtn) {
            printBtn.addEventListener('click', () => {
                window.print();
            });
        }
        
        // Modal triggers
        const modalTriggers = document.querySelectorAll('[data-modal-trigger="report-shatnez"]');
        modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.openModal();
            });
        });
    }
    
    initModal() {
        const modal = document.getElementById('report-shatnez-modal');
        const closeBtn = modal.querySelector('.modal-close');
        const languageToggle = modal.querySelector('.modal-language-toggle');
        
        // Language toggle functionality
        const langButtons = modal.querySelectorAll('.lang-btn');
        const formTitleEn = modal.querySelector('.form-title-en');
        const formTitleHe = modal.querySelector('.form-title-he');
        const formContainers = modal.querySelectorAll('.form-container');
        
        langButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const lang = btn.dataset.lang;
                
                // Update active button
                langButtons.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                // Toggle form titles
                if (lang === 'en') {
                    formTitleEn.style.display = 'block';
                    formTitleHe.style.display = 'none';
                } else {
                    formTitleEn.style.display = 'none';
                    formTitleHe.style.display = 'block';
                }
                
                // Toggle form containers
                formContainers.forEach(container => {
                    if (container.dataset.form === lang) {
                        container.style.display = 'block';
                    } else {
                        container.style.display = 'none';
                    }
                });
            });
        });

        // Hide language toggle after successful submission
        document.addEventListener('gform_confirmation_loaded', (event, formId) => {
            if ((formId === 1 || formId === 2) && languageToggle) {
                languageToggle.style.display = 'none';
            }
        });
        
        // Close modal events
        closeBtn.addEventListener('click', () => {
            this.closeModal();
        });
        
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                this.closeModal();
            }
        });
        
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('modal-open')) {
                this.closeModal();
            }
        });
    }
    
    openModal() {
        const modal = document.getElementById('report-shatnez-modal');
        const languageToggle = modal.querySelector('.modal-language-toggle');
        modal.classList.add('modal-open');
        document.body.classList.add('modal-open');

        if (languageToggle) {
            languageToggle.style.display = '';
        }
        
        // Focus trap
        const focusableElements = modal.querySelectorAll('button, input, select, textarea, a[href]');
        if (focusableElements.length > 0) {
            focusableElements[0].focus();
        }
    }
    
    closeModal() {
        const modal = document.getElementById('report-shatnez-modal');
        modal.classList.remove('modal-open');
        document.body.classList.remove('modal-open');
    }
    
    async loadItems() {
        try {
            const formData = new FormData();
            formData.append('action', 'get_shatnez_items');
            formData.append('location_type', this.locationType);
            formData.append('search', this.searchTerm);
            formData.append('sort_by', this.sortBy);
            formData.append('sort_direction', this.sortDirection);
            formData.append('page', this.currentPage);
            formData.append('nonce', window.shatnez_ajax.nonce);
            
            const response = await fetch(window.shatnez_ajax.ajaxurl, {
                method: 'POST',
                body: formData
            });
            
            const data = await response.json();
            
            if (data.success) {
                console.log('AJAX Response:', data.data); // Debug log
                this.items = data.data.items;
                this.isAdmin = data.data.is_admin;
                
                // Show/hide admin columns
                this.toggleAdminColumns();
                
                this.renderTable(data.data.items);
                this.renderCards(data.data.items);
                this.renderPagination(data.data.current_page, data.data.total_pages, data.data.found_posts);
                this.updateResultsCount(data.data.found_posts);
            } else {
                console.error('Error loading items:', data.data);
            }
        } catch (error) {
            console.error('Error loading items:', error);
        }
    }
    
    formatCondensedDate(dateString) {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return dateString; // Return original if invalid
            }
            
            // Detect if this is Hebrew/Israeli page
            const isHebrew = document.body.classList.contains('israel-listing') || 
                           document.documentElement.getAttribute('dir') === 'rtl' ||
                           window.location.pathname.includes('/israel');
            
            if (isHebrew) {
                const hebrewMonths = ['ינו׳', 'פבר׳', 'מרץ', 'אפר׳', 'מאי', 'יוני',
                                    'יולי', 'אוג׳', 'ספט׳', 'אוק׳', 'נוב׳', 'דצמ׳'];
                
                const month = hebrewMonths[date.getMonth()];
                const day = date.getDate();
                const year = date.getFullYear();
                
                return `${day} ${month} ${year}`;
            } else {
                const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                
                const month = months[date.getMonth()];
                const day = date.getDate();
                const year = date.getFullYear();
                
                return `${month} ${day}, ${year}`;
            }
        } catch (error) {
            return dateString; // Return original on error
        }
    }
    
    toggleAdminColumns() {
        const adminElements = document.querySelectorAll('.admin-only');
        adminElements.forEach(element => {
            element.style.display = this.isAdmin ? '' : 'none';
        });
    }
    
    getAdminActionsCell(item) {
        if (!this.isAdmin) return '';
        
        const isHebrew = document.body.classList.contains('israel-listing') || 
                       document.documentElement.getAttribute('dir') === 'rtl' ||
                       window.location.pathname.includes('/israel');
        
        const editText = isHebrew ? 'עריכה' : 'Edit';
        const deleteText = isHebrew ? 'מחיקה' : 'Delete';
        
        return `<td class="admin-only actions-cell">
            <div class="admin-actions">
                <button type="button" class="admin-btn edit-btn" data-post-id="${item.id}" title="${editText}">
                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                    </svg>
                </button>
                <button type="button" class="admin-btn delete-btn" data-post-id="${item.id}" title="${deleteText}">
                    <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                    </svg>
                </button>
            </div>
        </td>`;
    }

    renderTable(items) {
        const tableBody = document.getElementById('table-body');
        if (!tableBody) return;
        
        tableBody.innerHTML = '';
        
        items.forEach(item => {
            const row = document.createElement('tr');
            row.style.cursor = 'pointer';
            row.addEventListener('click', (e) => {
                // Don't navigate if clicking on admin buttons or image links
                if (!e.target.closest('.admin-actions') && !e.target.closest('.image-link')) {
                    window.location.href = item.url;
                }
            });
            
            // Detect if this is Hebrew/Israeli page
            const isHebrew = document.body.classList.contains('israel-listing') || 
                           document.documentElement.getAttribute('dir') === 'rtl' ||
                           window.location.pathname.includes('/israel');
            
            const clickText = isHebrew ? 'לחץ לצפייה' : 'Click to view';
            const noImagesText = isHebrew ? '' : '';
            
            const imageIcon = `<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
            </svg>`;
            
            const imageCell = item.has_images 
                ? `<a href="#" class="image-link" data-images='${JSON.stringify(item.images || [])}'>
                     ${imageIcon}
                   </a>`
                : noImagesText;
            
            if (isHebrew) {
                // Israeli page - no location column
                row.innerHTML = `
                    <td data-label="Date">${this.formatCondensedDate(item.date)}<br><small>${item.timeago}</small></td>
                    <td data-label="Type">${item.type || '-'}</td>
                    <td data-label="Company">${item.company || '-'}</td>
                    <td data-label="Details">
                        <div class="details-content">${this.truncateText(item.content || '', 80)}</div>
                        ${item.label_description ? `<div class="details-label">${this.truncateText(item.label_description, 60)}</div>` : ''}
                    </td>
                    <td data-label="היכן נמצא שעטנז">${item.where_found || '-'}</td>
                    <td data-label="Images">${imageCell}</td>
                    ${this.getAdminActionsCell(item)}
                `;
            } else {
                // International page - include location column
                row.innerHTML = `
                    <td data-label="Date">${this.formatCondensedDate(item.date)}<br><small>${item.timeago}</small></td>
                    <td data-label="Location"><span class="location-badge">${item.location}</span></td>
                    <td data-label="Type">${item.type || '-'}</td>
                    <td data-label="Company">${item.company || '-'}</td>
                    <td data-label="Details">
                        <div class="details-content">${this.truncateText(item.content || '', 80)}</div>
                        ${item.label_description ? `<div class="details-label">${this.truncateText(item.label_description, 60)}</div>` : ''}
                    </td>
                    <td data-label="Where Was Shatnez Found">${item.where_found || '-'}</td>
                    <td data-label="Images">${imageCell}</td>
                    ${this.getAdminActionsCell(item)}
                `;
            }
            tableBody.appendChild(row);
        });
    }
    
    renderCards(items) {
        const cardsWrapper = document.getElementById('cards-wrapper');
        if (!cardsWrapper) return;
        
        cardsWrapper.innerHTML = '';
        
        items.forEach(item => {
            // Detect if this is Hebrew/Israeli page
            const isHebrew = document.body.classList.contains('israel-listing') || 
                           document.documentElement.getAttribute('dir') === 'rtl' ||
                           window.location.pathname.includes('/israel');
            
            const clickText = isHebrew ? 'לחץ לצפייה' : 'Click to view';
            const noImagesText = isHebrew ? '' : '';
            
            const imageIcon = `<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
            </svg>`;
            
            const card = document.createElement('div');
            card.className = 'shatnez-card';
            card.style.cursor = 'pointer';
            card.addEventListener('click', (e) => {
                // Don't navigate if clicking on image links
                if (!e.target.closest('.image-link')) {
                    window.location.href = item.url;
                }
            });
            card.innerHTML = `
                <div class="card-header">
                    <h3 class="card-company">${item.company || 'Unknown Company'}</h3>
                    <div class="card-location"><span class="location-badge">${item.location}</span></div>
                </div>
                <div class="card-body">
                    <div class="card-details primary">
                        <div class="details-content">${this.truncateText(item.content || '', 120)}</div>
                        ${item.label_description ? `<div class="details-label">${this.truncateText(item.label_description, 80)}</div>` : ''}
                    </div>
                    <div class="card-meta secondary">
                        <div class="meta-item">
                            <span class="meta-label">Type:</span>
                            <span class="meta-value">${item.type || '-'}</span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">Where was shatnez found:</span>
                            <span class="meta-value">${item.where_found || '-'}</span>
                        </div>
                        <div class="meta-item">
                            <span class="meta-label">Date:</span>
                            <span class="meta-value">${this.formatCondensedDate(item.date)} (${item.timeago})</span>
                        </div>
                    </div>
                    <div class="card-images secondary">
                        ${item.has_images 
                            ? `<a href="#" class="image-link" data-images='${JSON.stringify(item.images || [])}'>
                                 ${imageIcon}
                               </a>`
                            : noImagesText
                        }
                    </div>
                </div>
            `;
            cardsWrapper.appendChild(card);
        });
    }
    
    initImageModal() {
        // Create image modal if it doesn't exist
        let imageModal = document.getElementById('image-modal');
        if (!imageModal) {
            // Detect if this is Hebrew/Israeli page
            const isHebrew = document.body.classList.contains('israel-listing') || 
                           document.documentElement.getAttribute('dir') === 'rtl' ||
                           window.location.pathname.includes('/israel');
            
            const modalTexts = isHebrew ? {
                title: 'תמונות שתנז',
                previous: '❮',
                next: '❯',
                close: '×'
            } : {
                title: 'Shatnez Images',
                previous: '<',
                next: '>',
                close: '×'
            };
            
            imageModal = document.createElement('div');
            imageModal.id = 'image-modal';
            imageModal.className = 'modal image-modal';
            imageModal.innerHTML = `
                <div class="modal-content image-modal-content">
                    <div class="modal-header">
                        <h3>${modalTexts.title}</h3>
                        <button type="button" class="modal-close">${modalTexts.close}</button>
                    </div>
                    <div class="modal-body image-modal-body">
                        <div class="image-container"></div>
                        <div class="image-navigation">
                            <button type="button" class="nav-btn prev-btn">${modalTexts.previous}</button>
                            <span class="image-counter">1 of 1</span>
                            <button type="button" class="nav-btn next-btn">${modalTexts.next}</button>
                        </div>
                    </div>
                </div>
            `;
            document.body.appendChild(imageModal);
        }
        
        // Bind image modal events
        this.bindImageModalEvents();
    }
    
    bindImageModalEvents() {
        // Handle image link clicks
        document.addEventListener('click', (e) => {
            if (e.target.closest('.image-link')) {
                e.preventDefault();
                const link = e.target.closest('.image-link');
                console.log('Image link clicked:', link); // Debug log
                
                try {
                    const imagesData = link.dataset.images || '[]';
                    console.log('Raw images data:', imagesData); // Debug log
                    const images = JSON.parse(imagesData);
                    console.log('Parsed images:', images); // Debug log
                    this.showImageModal(images);
                } catch (error) {
                    console.error('Error parsing image data:', error);
                    alert('Error loading images');
                }
            }
        });
        
        // Handle modal close
        const imageModal = document.getElementById('image-modal');
        if (imageModal) {
            const closeBtn = imageModal.querySelector('.modal-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => this.closeImageModal());
            }
            
            // Close on backdrop click
            imageModal.addEventListener('click', (e) => {
                if (e.target === imageModal) {
                    this.closeImageModal();
                }
            });
            
            // Navigation buttons
            const prevBtn = imageModal.querySelector('.prev-btn');
            const nextBtn = imageModal.querySelector('.next-btn');
            
            if (prevBtn) {
                prevBtn.addEventListener('click', () => this.showPreviousImage());
            }
            if (nextBtn) {
                nextBtn.addEventListener('click', () => this.showNextImage());
            }
        }
    }
    
    showImageModal(images) {
        console.log('showImageModal called with:', images); // Debug log
        
        if (!images || images.length === 0) {
            alert('No images available to display');
            return;
        }
        
        this.currentImages = images;
        this.currentImageIndex = 0;
        
        const modal = document.getElementById('image-modal');
        if (!modal) {
            console.error('Image modal not found');
            return;
        }
        
        const imageContainer = modal.querySelector('.image-container');
        const counter = modal.querySelector('.image-counter');
        const prevBtn = modal.querySelector('.prev-btn');
        const nextBtn = modal.querySelector('.next-btn');
        
        // Show current image
        this.updateImageDisplay();
        
        // Show/hide navigation
        if (prevBtn) prevBtn.style.display = images.length > 1 ? 'block' : 'none';
        if (nextBtn) nextBtn.style.display = images.length > 1 ? 'block' : 'none';
        if (counter) counter.style.display = images.length > 1 ? 'block' : 'none';
        
        modal.classList.add('modal-open');
        
        // Handle escape key
        this.imageModalEscapeHandler = (e) => {
            if (e.key === 'Escape') {
                this.closeImageModal();
            }
        };
        document.addEventListener('keydown', this.imageModalEscapeHandler);
    }
    
    updateImageDisplay() {
        const modal = document.getElementById('image-modal');
        const imageContainer = modal.querySelector('.image-container');
        const counter = modal.querySelector('.image-counter');
        
        // Detect if this is Hebrew/Israeli page
        const isHebrew = document.body.classList.contains('israel-listing') || 
                       document.documentElement.getAttribute('dir') === 'rtl' ||
                       window.location.pathname.includes('/israel');
        
        const currentImage = this.currentImages[this.currentImageIndex];
        const altText = isHebrew ? 'ראיות שתנז' : 'Shatnez evidence';
        const ofText = isHebrew ? 'מתוך' : 'of';
        
        imageContainer.innerHTML = `
            <img src="${currentImage.url}" alt="${altText}" class="modal-image">
            ${currentImage.caption ? `<p class="image-caption">${currentImage.caption}</p>` : ''}
        `;
        
        counter.textContent = isHebrew ? 
            `${this.currentImageIndex + 1} ${ofText} ${this.currentImages.length}` :
            `${this.currentImageIndex + 1} of ${this.currentImages.length}`;
    }
    
    showPreviousImage() {
        if (this.currentImageIndex > 0) {
            this.currentImageIndex--;
            this.updateImageDisplay();
        }
    }
    
    showNextImage() {
        if (this.currentImageIndex < this.currentImages.length - 1) {
            this.currentImageIndex++;
            this.updateImageDisplay();
        }
    }
    
    closeImageModal() {
        const modal = document.getElementById('image-modal');
        modal.classList.remove('modal-open');
        
        // Remove escape key handler
        if (this.imageModalEscapeHandler) {
            document.removeEventListener('keydown', this.imageModalEscapeHandler);
        }
        
        // Clean up
        this.currentImages = null;
        this.currentImageIndex = 0;
    }

    renderPagination(currentPage, totalPages, totalItems) {
        const paginationWrapper = document.getElementById('pagination-wrapper');
        if (!paginationWrapper || totalPages <= 1) {
            paginationWrapper.innerHTML = '';
            return;
        }
        
        let paginationHTML = '<nav class="page-navigation" role="navigation"><ul class="page-numbers">';
        
        // Previous button
        if (currentPage > 1) {
            paginationHTML += `<li><button class="page-number prev" data-page="${currentPage - 1}">‹ Previous</button></li>`;
        }
        
        // Page numbers
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, currentPage + 2);
        
        if (startPage > 1) {
            paginationHTML += `<li><button class="page-number" data-page="1">1</button></li>`;
            if (startPage > 2) {
                paginationHTML += '<li><span class="page-numbers dots">…</span></li>';
            }
        }
        
        for (let i = startPage; i <= endPage; i++) {
            const isActive = i === currentPage ? ' current' : '';
            paginationHTML += `<li><button class="page-number${isActive}" data-page="${i}">${i}</button></li>`;
        }
        
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                paginationHTML += '<li><span class="page-numbers dots">…</span></li>';
            }
            paginationHTML += `<li><button class="page-number" data-page="${totalPages}">${totalPages}</button></li>`;
        }
        
        // Next button
        if (currentPage < totalPages) {
            paginationHTML += `<li><button class="page-number next" data-page="${currentPage + 1}">Next ›</button></li>`;
        }
        
        paginationHTML += '</ul></nav>';
        paginationWrapper.innerHTML = paginationHTML;
        
        // Bind pagination events
        const pageButtons = paginationWrapper.querySelectorAll('.page-number');
        pageButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                const page = parseInt(e.target.dataset.page);
                if (page && page !== currentPage) {
                    this.currentPage = page;
                    this.loadItems();
                }
            });
        });
    }
    
    updateResultsCount(count) {
        const resultsCount = document.getElementById('results-count');
        if (resultsCount) {
            const text = this.locationType === 'israel' ? 
                `נמצאו ${count} דיווחים` : 
                `${count} reports found`;
            resultsCount.textContent = text;
        }
    }
    
    truncateText(text, maxLength) {
        if (!text) return '';
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    }
    
    exportCSV() {
        if (!this.items || this.items.length === 0) {
            alert('No data to export');
            return;
        }
        
        // Detect if this is Hebrew/Israeli page
        const isHebrew = document.body.classList.contains('israel-listing') || 
                       document.documentElement.getAttribute('dir') === 'rtl' ||
                       window.location.pathname.includes('/israel');
        
        // Prepare CSV data with appropriate headers
        let headers, csvData;
        
        if (isHebrew) {
            // Hebrew export - include all form fields
            headers = ['תאריך', 'מיקום', 'סוג', 'חברה', 'תיאור תווית', 'היכן נמצא שעטנז', 'נמצא על ידי', 'פרטים נוספים', 'אימייל ליצירת קשר', 'יש תמונות', 'מספר תמונות', 'קישור לדיווח'];
            csvData = [headers];
            
            this.items.forEach(item => {
                csvData.push([
                    this.formatCondensedDate(item.date),
                    item.location || '',
                    item.type || '',
                    item.company || '',
                    item.label_description || '',
                    item.where_found || '',
                    item.found_by || '',
                    item.content || '',
                    item.contact_email || '',
                    item.has_images ? 'כן' : 'לא',
                    item.image_count || 0,
                    item.url || ''
                ]);
            });
        } else {
            // International export - include all form fields
            headers = ['Date', 'Location', 'Type', 'Company', 'Label Description', 'Where Was Shatnez Found', 'Found By', 'Additional Details', 'Contact Email', 'Has Images', 'Image Count', 'Report URL'];
            csvData = [headers];
            
            this.items.forEach(item => {
                csvData.push([
                    this.formatCondensedDate(item.date),
                    item.location || '',
                    item.type || '',
                    item.company || '',
                    item.label_description || '',
                    item.where_found || '',
                    item.found_by || '',
                    item.content || '',
                    item.contact_email || '',
                    item.has_images ? 'Yes' : 'No',
                    item.image_count || 0,
                    item.url || ''
                ]);
            });
        }
        
        // Convert to CSV string
        const csvContent = Papa.unparse(csvData);
        
        // Create and download file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'shatnez-reports.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    
    bindAdminEvents() {
        // Handle edit buttons
        document.addEventListener('click', (e) => {
            if (e.target.closest('.edit-btn')) {
                const postId = e.target.closest('.edit-btn').dataset.postId;
                window.open(`${shatnez_ajax.adminurl}post.php?post=${postId}&action=edit`, '_blank');
            }
        });
        
        // Handle delete buttons
        document.addEventListener('click', (e) => {
            if (e.target.closest('.delete-btn')) {
                const button = e.target.closest('.delete-btn');
                const postId = button.dataset.postId;
                
                const isHebrew = document.body.classList.contains('israel-listing') || 
                               document.documentElement.getAttribute('dir') === 'rtl' ||
                               window.location.pathname.includes('/israel');
                
                const confirmMessage = isHebrew ? 
                    'האם אתה בטוח שברצונך למחוק את הדיווח הזה? פעולה זו לא ניתנת לביטול.' :
                    'Are you sure you want to delete this report? This action cannot be undone.';
                
                if (confirm(confirmMessage)) {
                    this.deletePost(postId);
                }
            }
        });
    }
    
    async deletePost(postId) {
        try {
            const formData = new FormData();
            formData.append('action', 'delete_shatnez_item');
            formData.append('post_id', postId);
            formData.append('nonce', shatnez_ajax.nonce);
            
            const response = await fetch(shatnez_ajax.ajaxurl, {
                method: 'POST',
                body: formData
            });
            
            const data = await response.json();
            
            if (data.success) {
                // Reload the current page data
                this.loadItems();
                
                const isHebrew = document.body.classList.contains('israel-listing') || 
                               document.documentElement.getAttribute('dir') === 'rtl' ||
                               window.location.pathname.includes('/israel');
                
                const successMessage = isHebrew ? 'הדיווח נמחק בהצלחה' : 'Report deleted successfully';
                alert(successMessage);
            } else {
                const isHebrew = document.body.classList.contains('israel-listing') || 
                               document.documentElement.getAttribute('dir') === 'rtl' ||
                               window.location.pathname.includes('/israel');
                
                const errorMessage = isHebrew ? 'שגיאה במחיקת הדיווח' : 'Error deleting report';
                alert(errorMessage + ': ' + (data.data.message || 'Unknown error'));
            }
        } catch (error) {
            console.error('Error deleting post:', error);
            const isHebrew = document.body.classList.contains('israel-listing') || 
                           document.documentElement.getAttribute('dir') === 'rtl' ||
                           window.location.pathname.includes('/israel');
            
            const errorMessage = isHebrew ? 'שגיאה במחיקת הדיווח' : 'Error deleting report';
            alert(errorMessage);
        }
    }
}

// Make ShatnezListing globally available
window.ShatnezListing = ShatnezListing;

// Initialize modal functionality on frontpage
(function() {
    'use strict';
    
    function initFrontpageModal() {
        const modalTriggers = document.querySelectorAll('[data-modal-trigger="report-shatnez"]');
        const modal = document.getElementById('report-shatnez-modal');
        
        if (modalTriggers.length === 0 || !modal) return;
        
        // Language toggle functionality
        const langButtons = modal.querySelectorAll('.lang-btn');
        const formTitleEn = modal.querySelector('.form-title-en');
        const formTitleHe = modal.querySelector('.form-title-he');
        const formContainers = modal.querySelectorAll('.form-container');
        const languageToggle = modal.querySelector('.modal-language-toggle');
        
        langButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const lang = btn.dataset.lang;
                
                // Update active button
                langButtons.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                // Toggle form titles
                if (lang === 'en') {
                    formTitleEn.style.display = 'block';
                    formTitleHe.style.display = 'none';
                } else {
                    formTitleEn.style.display = 'none';
                    formTitleHe.style.display = 'block';
                }
                
                // Toggle form containers
                formContainers.forEach(container => {
                    if (container.dataset.form === lang) {
                        container.style.display = 'block';
                    } else {
                        container.style.display = 'none';
                    }
                });
            });
        });

        // Hide language toggle after successful submission
        document.addEventListener('gform_confirmation_loaded', (event, formId) => {
            if ((formId === 1 || formId === 2) && languageToggle) {
                languageToggle.style.display = 'none';
            }
        });
        
        modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                modal.classList.add('modal-open');
                document.body.classList.add('modal-open');

                if (languageToggle) {
                    languageToggle.style.display = '';
                }
            });
        });
        
        const closeBtn = modal.querySelector('.modal-close');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            });
        }
        
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }
        });
        
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('modal-open')) {
                modal.classList.remove('modal-open');
                document.body.classList.remove('modal-open');
            }
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFrontpageModal);
    } else {
        initFrontpageModal();
    }
})();